/* Circle */
var ele = document.getElementsByClassName('chart'); // get canvas

for(var i=0, l=ele.length; i<l; i++) {
	var el = ele[i];
	var options = {
		percent:  el.getAttribute('data-percent') || 25,
		size: el.getAttribute('data-size') || 220,
		lineWidth: el.getAttribute('data-line') || 15,
		rotate: el.getAttribute('data-rotate') || 270
	}
	
	var canvas = document.createElement('canvas');
	var span = document.createElement('span');
	span.textContent = options.percent + '%';
		
	if (typeof(G_vmlCanvasManager) !== 'undefined') {
		G_vmlCanvasManager.initElement(canvas);
	}
	
	var ctx = canvas.getContext('2d');
	canvas.width = canvas.height = options.size;
	
	el.appendChild(span);
	el.appendChild(canvas);
	
	ctx.translate(options.size / 2, options.size / 2); // change center
	ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg
	
	//imd = ctx.getImageData(0, 0, 240, 240);
	var radius = (options.size - options.lineWidth) / 2;
	
	var drawCircle = function(color, lineWidth, percent) {
		percent = Math.min(Math.max(0, percent || 1), 1);
		ctx.beginPath();
		ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
		ctx.strokeStyle = color;
		ctx.lineCap = 'round'; // butt, round or square
		ctx.lineWidth = lineWidth
		ctx.stroke();
	};
	
	if(options.percent <= 0) {
		drawCircle('#efefef', options.lineWidth, 100 / 100);
	}	
	else { 
		drawCircle('#efefef', options.lineWidth, 100 / 100);
		drawCircle('#555555', options.lineWidth, options.percent / 100);
	}
}

var sb = new ShareButton('', {
	ui: {
		buttonText: 'Spread Campaign'
	}
});


/**
 * Particleground
 *
 * @author Jonathan Nicol - @mrjnicol
 * @version 1.0.1
 * @description Creates a canvas based particle system background
 *
 * Inspired by:
 * http://requestlab.fr/
 * http://disruptivebydesign.com/
 *
 * @license The MIT License (MIT)
 *
 * Copyright (c) 2014 Jonathan Nicol - @mrjnicol
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
!function(a){function b(b,d){function e(){if(w){$canvas=a('<canvas class="pg-canvas"></canvas>'),v.prepend($canvas),p=$canvas[0],q=p.getContext("2d"),f();for(var b=Math.round(p.width*p.height/d.density),c=0;b>c;c++){var e=new l;e.setStackPos(c),x.push(e)}a(window).on("resize",function(){h()}),a(document).on("mousemove",function(a){y=a.pageX,z=a.pageY}),B&&!A&&window.addEventListener("deviceorientation",function(){D=Math.min(Math.max(-event.beta,-30),30),C=Math.min(Math.max(-event.gamma,-30),30)},!0),g(),o("onInit")}}function f(){p.width=v.width(),p.height=v.height(),q.fillStyle=d.dotColor,q.strokeStyle=d.lineColor,q.lineWidth=d.lineWidth}function g(){if(w){s=a(window).width(),t=a(window).height(),q.clearRect(0,0,p.width,p.height);for(var b=0;b<x.length;b++)x[b].updatePosition();for(var b=0;b<x.length;b++)x[b].draw();E||(r=requestAnimationFrame(g))}}function h(){for(f(),i=x.length-1;i>=0;i--)(x[i].position.x>v.width()||x[i].position.y>v.height())&&x.splice(i,1);var a=Math.round(p.width*p.height/d.density);if(a>x.length)for(;a>x.length;){var b=new l;x.push(b)}else a<x.length&&x.splice(a);for(i=x.length-1;i>=0;i--)x[i].setStackPos(i)}function j(){E=!0}function k(){E=!1,g()}function l(){switch(this.stackPos,this.active=!0,this.layer=Math.ceil(3*Math.random()),this.parallaxOffsetX=0,this.parallaxOffsetY=0,this.position={x:Math.ceil(Math.random()*p.width),y:Math.ceil(Math.random()*p.height)},this.speed={},d.directionX){case"left":this.speed.x=+(-d.maxSpeedX+Math.random()*d.maxSpeedX-d.minSpeedX).toFixed(2);break;case"right":this.speed.x=+(Math.random()*d.maxSpeedX+d.minSpeedX).toFixed(2);break;default:this.speed.x=+(-d.maxSpeedX/2+Math.random()*d.maxSpeedX).toFixed(2),this.speed.x+=this.speed.x>0?d.minSpeedX:-d.minSpeedX}switch(d.directionY){case"up":this.speed.y=+(-d.maxSpeedY+Math.random()*d.maxSpeedY-d.minSpeedY).toFixed(2);break;case"down":this.speed.y=+(Math.random()*d.maxSpeedY+d.minSpeedY).toFixed(2);break;default:this.speed.y=+(-d.maxSpeedY/2+Math.random()*d.maxSpeedY).toFixed(2),this.speed.x+=this.speed.y>0?d.minSpeedY:-d.minSpeedY}}function m(a,b){return b?void(d[a]=b):d[a]}function n(){v.find(".pg-canvas").remove(),o("onDestroy"),v.removeData("plugin_"+c)}function o(a){void 0!==d[a]&&d[a].call(u)}var p,q,r,s,t,u=b,v=a(b),w=!!document.createElement("canvas").getContext,x=[],y=0,z=0,A=!navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i),B=!!window.DeviceOrientationEvent,C=0,D=0,E=!1;return d=a.extend({},a.fn[c].defaults,d),l.prototype.draw=function(){q.beginPath(),q.arc(this.position.x+this.parallaxOffsetX,this.position.y+this.parallaxOffsetY,d.particleRadius/2,0,2*Math.PI,!0),q.closePath(),q.fill(),q.beginPath();for(var a=x.length-1;a>this.stackPos;a--){var b=x[a],c=this.position.x-b.position.x,e=this.position.y-b.position.y,f=Math.sqrt(c*c+e*e).toFixed(2);f<d.proximity&&(q.moveTo(this.position.x+this.parallaxOffsetX,this.position.y+this.parallaxOffsetY),d.curvedLines?q.quadraticCurveTo(Math.max(b.position.x,b.position.x),Math.min(b.position.y,b.position.y),b.position.x+b.parallaxOffsetX,b.position.y+b.parallaxOffsetY):q.lineTo(b.position.x+b.parallaxOffsetX,b.position.y+b.parallaxOffsetY))}q.stroke(),q.closePath()},l.prototype.updatePosition=function(){if(d.parallax){if(B&&!A){var a=(s-0)/60;pointerX=(C- -30)*a+0;var b=(t-0)/60;pointerY=(D- -30)*b+0}else pointerX=y,pointerY=z;this.parallaxTargX=(pointerX-s/2)/(d.parallaxMultiplier*this.layer),this.parallaxOffsetX+=(this.parallaxTargX-this.parallaxOffsetX)/10,this.parallaxTargY=(pointerY-t/2)/(d.parallaxMultiplier*this.layer),this.parallaxOffsetY+=(this.parallaxTargY-this.parallaxOffsetY)/10}switch(d.directionX){case"left":this.position.x+this.speed.x+this.parallaxOffsetX<0&&(this.position.x=v.width()-this.parallaxOffsetX);break;case"right":this.position.x+this.speed.x+this.parallaxOffsetX>v.width()&&(this.position.x=0-this.parallaxOffsetX);break;default:(this.position.x+this.speed.x+this.parallaxOffsetX>v.width()||this.position.x+this.speed.x+this.parallaxOffsetX<0)&&(this.speed.x=-this.speed.x)}switch(d.directionY){case"up":this.position.y+this.speed.y+this.parallaxOffsetY<0&&(this.position.y=v.height()-this.parallaxOffsetY);break;case"down":this.position.y+this.speed.y+this.parallaxOffsetY>v.height()&&(this.position.y=0-this.parallaxOffsetY);break;default:(this.position.y+this.speed.y+this.parallaxOffsetY>v.height()||this.position.y+this.speed.y+this.parallaxOffsetY<0)&&(this.speed.y=-this.speed.y)}this.position.x+=this.speed.x,this.position.y+=this.speed.y},l.prototype.setStackPos=function(a){this.stackPos=a},e(),{option:m,destroy:n,start:k,pause:j}}var c="particleground";a.fn[c]=function(d){if("string"==typeof arguments[0]){var e,f=arguments[0],g=Array.prototype.slice.call(arguments,1);return this.each(function(){a.data(this,"plugin_"+c)&&"function"==typeof a.data(this,"plugin_"+c)[f]&&(e=a.data(this,"plugin_"+c)[f].apply(this,g))}),void 0!==e?e:this}return"object"!=typeof d&&d?void 0:this.each(function(){a.data(this,"plugin_"+c)||a.data(this,"plugin_"+c,new b(this,d))})},a.fn[c].defaults={minSpeedX:.1,maxSpeedX:.7,minSpeedY:.1,maxSpeedY:.7,directionX:"center",directionY:"center",density:1e4,dotColor:"#666666",lineColor:"#666666",particleRadius:7,lineWidth:1,curvedLines:!1,proximity:100,parallax:!0,parallaxMultiplier:5,onInit:function(){},onDestroy:function(){}}}(jQuery),/**
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * @see: http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * @see: http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * @license: MIT license
 */
function(){for(var a=0,b=["ms","moz","webkit","o"],c=0;c<b.length&&!window.requestAnimationFrame;++c)window.requestAnimationFrame=window[b[c]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[b[c]+"CancelAnimationFrame"]||window[b[c]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(b){var c=(new Date).getTime(),d=Math.max(0,16-(c-a)),e=window.setTimeout(function(){b(c+d)},d);return a=c+d,e}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)})}();

$(function(){

    $('.jtr').particleground({
        minSpeedX: 0.1,
        maxSpeedX: 0.7,
        minSpeedY: 0.1,
        maxSpeedY: 0.7,
        directionX: 'center', // 'center', 'left' or 'right'. 'center' = dots bounce off edges
        directionY: 'center', // 'center', 'up' or 'down'. 'center' = dots bounce off edges
        density: 10000, // How many particles will be generated: one particle every n pixels
        dotColor: '#eee',
        lineColor: '#eee',
        particleRadius: 7, // Dot size
        lineWidth: 1,
        curvedLines: true,
        proximity: 100, // How close two dots need to be before they join
        parallax: false
    });

});

/* Vertical timeliens */
jQuery(document).ready(function($){
	var timelineBlocks = $('.cd-timeline-block'),
		offset = 0.8;

	//hide timeline blocks which are outside the viewport
	hideBlocks(timelineBlocks, offset);

	//on scolling, show/animate timeline blocks when enter the viewport
	$(window).on('scroll', function(){
		(!window.requestAnimationFrame)
			? setTimeout(function(){ showBlocks(timelineBlocks, offset); }, 100)
			: window.requestAnimationFrame(function(){ showBlocks(timelineBlocks, offset); });
	});

	function hideBlocks(blocks, offset) {
		blocks.each(function(){
			( $(this).offset().top > $(window).scrollTop()+$(window).height()*offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
		});
	}

	function showBlocks(blocks, offset) {
		blocks.each(function(){
			( $(this).offset().top <= $(window).scrollTop()+$(window).height()*offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
		});
	}

	var faq = $(".faq-list-item");

	if(faq.length > 0){
		faq.on("click", function(e){
			var $this = $(this);

			if($this.hasClass("active")){
				return false;
			}else{
				var activeFaqItem = $(".faq-list-item.active");
				var activeSpan = $(activeFaqItem.find("span.fa"));
				var currentSpan = $($this.find("span.fa"));
				var activeContent = $(activeFaqItem.find(".faq-list-item-content"));
				var currentContent = $($this.find(".faq-list-item-content"));


				activeFaqItem.removeClass("active");
				activeSpan.removeClass("fa-minus").addClass("fa-plus");
				currentSpan.removeClass("fa-plus").addClass("fa-minus");
				$this.addClass("active");
				activeContent.slideUp();
				currentContent.slideDown();

			}
		})
	}
});

/* Demo Scripts for Bootstrap Carousel and Animate.css article
* on SitePoint by Maria Antonietta Perna
*/
(function( $ ) {

    // var senseSpeed = 5;
    // var previousScroll = 0;
    // $(window).scroll(function(event){
    //    var scroller = $(this).scrollTop();
    //    if (scroller-senseSpeed > previousScroll){
    //       $("#mainNav").filter(':not(:animated)').slideUp();
    //    } else if (scroller+senseSpeed < previousScroll) {
    //       $("#mainNav").filter(':not(:animated)').slideDown();
    //    }
    //    previousScroll = scroller;
    // });

	//Function to animate slider captions
	function doAnimations( elems ) {
		//Cache the animationend event in a variable
		var animEndEv = 'webkitAnimationEnd animationend';

		elems.each(function () {
			var $this = $(this),
				$animationType = $this.data('animation');
			$this.addClass($animationType).one(animEndEv, function () {
				$this.removeClass($animationType);
			});
		});
	}

	//Variables on page load
	var $myCarousel = $('#carousel-example-generic'),
		$firstAnimatingElems = $myCarousel.find('.item:first').find("[data-animation ^= 'animated']");

	//Initialize carousel
	$myCarousel.carousel();

	//Animate captions in first slide on page load
	doAnimations($firstAnimatingElems);

	//Pause carousel
	$myCarousel.carousel('pause');


	//Other slides to be animated on carousel slide event
	$myCarousel.on('slide.bs.carousel', function (e) {
		var $animatingElems = $(e.relatedTarget).find("[data-animation ^= 'animated']");
		doAnimations($animatingElems);
	});


    //Read Notifications
	$('.notification-dropdown > a').on('click.bs.dropdown', function() {
		var self = $(this);
		$.ajax({
			url: '/users/notifications/seen',
			method: 'post',
			data: '&empty=1',
			success: function(response) {
				if (response == 200) {
					$(self).children('.badge').addClass('hidden');
				}
			}
		});
	})
	
    $('.notification-item').on('click', function(e, el) {		
		
        var self = this;

        var notification_id = $(self).attr('notificationId');
        resourceUser = $(self).attr('resourceUser');

        $.ajax({
            url: '/users/notifications',
            method : 'post',
            data: '&notification_id='+notification_id,
            success: function(response) {
                //window.location.href = '/users/'+resourceUser;
            }
        });
    });

})(jQuery);


/* Site Scripts */
/* (c) Praise_ */


jQuery.fn.preventDoubleSubmit = function() {
  jQuery(this).submit(function() {
    if (this.beenSubmitted)
      return false;
    else
      this.beenSubmitted = true;
  });
};

jQuery('form button[type=submit]').preventDoubleSubmit();

$(document).ready(function() {
	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
		}
	});
	
	
	/* footables */
	$('.footable').footable();
	
	/*affix*/
	$('.awareness .signups.desktop').affix({
		offset: {
			top: $('#mainNav').outerHeight(true) - 10,
			bottom: ($('.footer').outerHeight(true) + $('.footer-copyright').outerHeight(true)) + 20	
		}
	})
	
	$('.profile-sidebar').affix({
		offset: {
			top: $('#profile-wall-photo').outerHeight(true) - 10,
			bottom: ($('.footer').outerHeight(true) + $('.footer-copyright').outerHeight(true)) + 50	
		}
	})
	
	
	$('.item > .panel .panel-body img').hover(function() {		
		self = $(this);
		old_attr = self.attr('src');
		console.log(old_attr);
		
		$(this).animate({
			'opacity': 0.7
		});
		
	}, function() {
		$(this).animate({
			'opacity': 1
		}).attr('src', old_attr);
	});
	
	$('.datepicker').datepicker({
		format: 'yyyy-mm-dd'
	});
	
	/* Numpad */
	
	// Set NumPad defaults for jQuery mobile. 
	// These defaults will be applied to all NumPads within this document!
	$.fn.numpad.defaults.gridTpl = '<table class="table modal-content"></table>';
	$.fn.numpad.defaults.backgroundTpl = '<div class="modal-backdrop in"></div>';
	$.fn.numpad.defaults.displayTpl = '<input type="text" class="form-control" />';
	$.fn.numpad.defaults.buttonNumberTpl =  '<button type="button" class="btn btn-default"></button>';
	$.fn.numpad.defaults.buttonFunctionTpl = '<button type="button" class="btn" style="width: 100%;"></button>';
	$.fn.numpad.defaults.onKeypadCreate = function(){$(this).find('.done').addClass('btn-primary');};
			
	$('.numpad').numpad({
		displayTpl: '<input class="form-control" type="password" />',
		hidePlusMinusButton: true,
		hideDecimalButton: true
	});
	
	$('input[type=number]').numpad({
		displayTpl: '<input class="form-control" type="password" />',
		hidePlusMinusButton: true,
		hideDecimalButton: true
	});
	
	/* Zone selector */
	$('.zoneSelector').on('change', function(el) {

		var selection = $(this).val();
		
		if (selection == "blwzone")
		{
			$('.selection').html('<input type="text" class="form-control input-sm" name="referrer" placeholder="Specify your zone here" required>');
		}
		else
		{
			$('.selection input').remove();
		}
		

		/* listen for cancel event */
		$('.cancleSelection').on('click', function() {
			alert('cancelling...');
		})
	})
	
	
	/* Masonry & Infinite-Scroll */

	var $container = $('.masonry-container');
	$container.imagesLoaded(function() {
		$container.masonry({
			columnWidth: '.item',
			itemSelector: '.item'
		});
	});
	
	$('.projects-tabs').each(function() {
		var $this = $(this);
		
		$this.on('shown.bs.tab', function() {
			$container.imagesLoaded(function() {
				$container.masonry({
					columnWidth: '.item',
					itemSelector: '.item'
				});
			});
		});
	});
	
	
	$('.projects-item-container .row').infinitescroll({
		navSelector  : ".pagination",            
                 // selector for the paged navigation (it will be hidden)
 
		nextSelector : "ul.pagination a:first",    
						// selector for the NEXT link (to page 2)
		
		itemSelector : ".projects-item-container div.item",          
						// selector for all items you'll retrieve
		
		debug        : false,                        
						// enable debug messaging ( to console.log )
		
		loadingImg   : "/img/loading.gif",          
						// loading image.
						// default: "http://www.infinite-scroll.com/loading.gif"
		
		loadingText  : "loading",      
						// text accompanying loading image
						// default: "<em>Loading the next set of posts...</em>"
		
		animate      : false,      
						// boolean, if the page will do an animated scroll when new content loads
						// default: false
		
		extraScrollPx: 0,      
						// number of additonal pixels that the page will scroll 
						// (in addition to the height of the loading div)
						// animate must be true for this to matter
						// default: 150
		
		donetext     : "loading" ,
						// text displayed when all items have been retrieved
						// default: "<em>Congratulations, you've reached the end of the internet.</em>"
		
		bufferPx     : 500,
						// increase this number if you want infscroll to fire quicker
						// (a high number means a user will not see the loading message)
						// new in 1.2
						// default: 40
		
		errorCallback: function(){},
						// called when a requested page 404's or when there is no more content
						// new in 1.2                   
		
		localMode    : true
	}, function(items) {
		
		$('.projects-item-container .item').attr('style','');
		
		
		
		//fire circle-progress
		$('#carousel-stats').carousel({ interval: 2000});
	
		$('.circle').circleProgress({
		thickness: 3,
		fill: {
			gradient: ["#51BFFA", "orange"]
		}
		}).on('circle-animation-progress', function(event, progress, stepValue) {
		//$(this).find('strong').html(parseInt(100 * progress) + '<i>%</i>');
		$(this).find('strong').text(String(stepValue.toFixed(2)).substr(2) + '%');
		});
		
		/* hover */
		$('.item > .panel .panel-body img').hover(function() {		
			self = $(this);
			old_attr = self.attr('src');
			console.log(old_attr);
			
			$(this).animate({
				'opacity': 0.7
			});
			
		}, function() {
			$(this).animate({
				'opacity': 1
			}).attr('src', old_attr);
		});
		
		var $items = $(items);
		$container.masonry('appended', $items);
	});
	
	/* Cross Browser Date Picker */
	// if(!Modernizr.inputtypes.date) {
	// 	$('.datepicker').datepicker({
	// 		format: 'yyyy-mm-dd'
	// 	});
	// }
	
	/* BS Tooltips */
	$(function () {
	$('[data-toggle="tooltip"]').tooltip()
	});
	
	$('.navbar-nav').on('click', '.getstarted', function(e) {
		e.preventDefault();
		$(this).addClass('closestarted').removeClass('getstarted');
	
		$('#mainNav').addClass('hasLanding');
		$('#landingPage').slideDown();
	});
	
	$('.navbar-nav').on('click', '.closestarted', function(e) {
		e.preventDefault();
		$(this).addClass('getstarted').removeClass('closestarted');
	
		$('#mainNav').removeClass('hasLanding');
		$('#landingPage').slideUp();
	});
	
	$('.closeSplash').on('click', function(e) {
		e.preventDefault();
		$('.closestarted').trigger('click');
	});
	
	//smooth scroll
	$(".scroll").click(function(event){
		event.preventDefault();
		$('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
	});
	
	//follow
	$('.author').on('click', '.ajaxFollow', function(e) {
		e.preventDefault();
		var $self = e.currentTarget;
		var userId = $self.getAttribute('userId');
		var userIdToFollow = $self.getAttribute('userIdToFollow');
	
		$.ajax({
			url: '/users/me/followers/follow',
			data: '&userId='+ userId + '&userIdToFollow='+userIdToFollow,
			method: 'post',
			success: function(response) {
				if (response) {
					$($self).html('Following').removeClass('ajaxFollow outline').addClass('ajaxUnFollow btn-info text-muted-white').attr('userIdToUnFollow', +userIdToFollow);
	
				}
			}
		});
	});
	
	//unfollow
	$('.author').on('click', '.ajaxUnFollow', function(e) {
		e.preventDefault();
		//alert(e.currentTarget.attr('class'))
		var $self = e.currentTarget;
	
		var userId = $self.getAttribute('userId');
		var userIdToUnFollow = $self.getAttribute('userIdToUnFollow');
	
		$.ajax({
			url: '/users/me/followers/unfollow',
			data: '&userId='+ userId + '&userIdToUnFollow='+userIdToUnFollow,
			method: 'post',
			success: function(response) {
				if (response) {
					$($self).html('<i class="fa fa-fw fa-heart-o"></i> Follow').removeClass('btn-info ajaxUnFollow text-muted-white').addClass('ajaxFollow outline').attr('userIdToFollow', +userIdToUnFollow);;
				}
			}
		});
	});
	
	//set currency
	$( document.body ).on( 'click', '.currency .dropdown-menu li', function( event ) {
	
		var $target = $( event.currentTarget );
	
		//Todo ajax req $target.text()
		$target.closest( '.btn-group' )
			.find( '[data-bind="label"]' ).html( $target.html() )
				.end()
			.children( '.dropdown-toggle' ).dropdown( 'toggle' );
		console.log($target.text());
		$.ajax({
			url: '/users/currency',
			data: '&currency='+$target.text(),
			method: 'post',
			success: function(response) {
				window.document.location.reload();
			}
		});
	
		return false;
	
	});

	//Setting Currency for voucher
	$('#currency .dropdown-menu li').on( 'click', function( event ) {

		var $target = $( event.currentTarget ),
		 $inputValue = $('input#currency_code');
			
		//Todo ajax req $target.text()
		$target.closest( '.btn-group' )
			.find( '[data-bind="label"]' ).html( $target.html() )
				.end()
			.children( '.dropdown-toggle' ).dropdown( 'toggle' );
			
		
		$targetText = $target.text();
		switch ($targetText.trim()) {
            case '₦':
            	$inputValue.attr('value', 'NGN');
                break;

            case '$':
           		 $inputValue.attr('value', 'USD');
                break;

            case '€':
                $inputValue.attr('value', 'EUR');
                break;
           
           case '£':
                $inputValue.attr('value', 'GBP');
                break;
                
            case 'R':
                $inputValue.attr('value', 'ZAR');
                break;

            case '¥':
                $inputValue.attr('value', 'CNY');
                break;
            default:
            	$inputValue.attr('value', 'NGN'); 
            }
		//console.log($inputValue.val());
	});
	
	$('input[id=wallphoto]').on('change', function() {
		$('.profile-wall-photo-wrapper .spinner').css('visibility', 'visible');
	
		var options = {
			beforeSend: function()
			{
				$('.profile-wall-photo-wrapper .spinner').css('visibility', 'visible');
			},
			success: function()
			{
				$('.profile-wall-photo-wrapper .spinner').css('visibility', 'hidden');
				sweetAlert( 'Good job!','Wall Photo uploaded successfully', 'success');
			},
			complete: function(response)
			{
				$('.profile-wall-photo-wrapper .spinner').css('visibility', 'hidden');
				$('.profile-wall-photo-wrapper').css('background', 'url('+response.responseText+') center center no-repeat');
			},
			error: function(response)
			{
				var errorHtml = '<ul class="list-unstyled">';
	
				var errors = JSON.parse(response.responseText);
	
				$.each(errors['wallphoto'], function(index, error) {
					errorHtml += '<li>'+error+'</li>';
				});
				errorHtml += '</ul>';
	
				sweetAlert({
					title: '<i class="fa fa-fw fa-exclamation-triangle"></i> Oops',
					text: errorHtml,
					html:true
				});
			}
		};
		$(".wallphotoForm").ajaxSubmit(options);
	});
	
	$(".fileUpload").on('change', function () {
		//Get count of selected files
		var parent = $(this).parent();
		var countFiles = $(this)[0].files.length;
	
		var imgPath = $(this)[0].value;
		var extn = imgPath.substring(imgPath.lastIndexOf('.') + 1).toLowerCase();
		var image_holder = $(this).parent().find('.image-preview');
		image_holder.empty();
	
		if (extn == "gif" || extn == "png" || extn == "jpg" || extn == "jpeg") {
			if (typeof (FileReader) != "undefined") {
	
				//loop for each file selected for uploaded.
				for (var i = 0; i < countFiles; i++) {
	
					var reader = new FileReader();
					reader.onload = function (e) {
						$("<img />", {
							"min-width":300,
							"max-width":'100%',
							"min-height":300,
							"max-height":'auto',
							
							"src": e.target.result,
								"class": "thumb-image img-rounded img-responsive"
						}).appendTo(image_holder);
					}
	
					image_holder.show();
					reader.readAsDataURL($(this)[0].files[i]);
				}
	
			} else {
				alert("This browser does not support FileReader.");
			}
		} else {
			alert("Pls select only images");
		}
	});
	
	$('#flash-overlay-modal').modal();
	$('div.alert').not('.alert-danger,.alert-stay').delay(3000).slideUp(300);
	
	//Toggle states
	$('.dashboard-menu .collapse').on('show.bs.collapse', function() {
	$(this).parent().children().children('span.fa').addClass('fa-chevron-down');
	})
	$('.dashboard-menu .collapse').on('hidden.bs.collapse', function() {
	$(this).parent().children().children('span.fa').removeClass('fa-chevron-down');
	})
	//admin menu nav
	$('.dashboard-menu .collapse .active').parent().addClass('in').removeClass('collapse').parent().children().children('span.fa').addClass('fa-chevron-down');
	
	$('.categories label').on('click', function() {
	$('.categories label').removeClass('active btn-default');
	$(this).addClass('active btn-default');
	});
	
	// $('.category .header').affix({
	//     offset: {
	//         top: $('.category .header').offset().top
	//     }
	// });
	
	$('.summernote').summernote({
	height: 300,
	});
	
	
	//$('#carousel-example-generic').carousel({});
	$('#carousel-stats').carousel({ interval: 2000});
	
	$('.circle').circleProgress({
	thickness: 3,
	fill: {
		gradient: ["#51BFFA", "orange"]
	}
	}).on('circle-animation-progress', function(event, progress, stepValue) {
	//$(this).find('strong').html(parseInt(100 * progress) + '<i>%</i>');
	$(this).find('strong').text(String(stepValue.toFixed(2)).substr(2) + '%');
	});

	$("#updateVideo").on('show.bs.modal', function(event){
        var button = $(event.relatedTarget);  // Button that triggered the modal
        var $this = $(this);
        var formInputs = $this.find('input');
        var forms = $this.find('form');
        var buttonTD = button.closest('tr').find('td');
        var vidID = button.closest('tr').find('input[type=hidden]').eq(0).val();
        var vidTitle = buttonTD.eq(0).text();
        var vidURL = buttonTD.eq(1).text();
        forms.eq(0).attr('action', '/admin/edit-inspired-video/'+vidID);
        formInputs.eq(2).val(vidTitle);
        formInputs.eq(3).val(vidURL);
    });

    $("#publish-video").on('show.bs.modal', function(event){
        var button = $(event.relatedTarget);  // Button that triggered the modal
        var $this = $(this);
        var modalTitle = $this.find('.modal-title');
        var modalBody = $this.find('.modal-body');
        var formSubmitBtn = $this.find('button[type=submit]');
        var forms = $this.find('form');
        var buttonTD = button.closest('tr').find('td');
        var vidID = button.closest('tr').find('input[type=hidden]').eq(0).val();
        var vidTitle = buttonTD.eq(0).text();
        if(button.text().trim() == 'Publish'){
        	formSubmitBtn.eq(0).removeClass('btn-info')
        				.addClass('btn-success');
        }else{
        	formSubmitBtn.eq(0).removeClass('btn-success')
        				.addClass('btn-info');
        }
        formSubmitBtn.eq(0).text(button.text());
        forms.eq(0).attr('action', '/admin/publish-inspired-video/'+vidID);
        modalTitle.eq(0).text(button.text().trim()+' '+vidTitle);
        modalBody.eq(0).html('<p>Are you sure you want to '+button.text().toLowerCase().trim()+' '+vidTitle.trim()+'?</p>');
    });

    $("#delete-video").on('show.bs.modal', function(event){
        var button = $(event.relatedTarget);  // Button that triggered the modal
        var $this = $(this);
        var modalTitle = $this.find('.modal-title');
        var modalBody = $this.find('.modal-body');
        var formSubmitBtn = $this.find('button[type=submit]');
        var forms = $this.find('form');
        var buttonTD = button.closest('tr').find('td');
        var vidID = button.closest('tr').find('input[type=hidden]').eq(0).val();
        var vidTitle = buttonTD.eq(0).text();
        forms.eq(0).attr('action', '/admin/delete-inspired-video/'+vidID);
        modalTitle.eq(0).text('Delete '+vidTitle);
        modalBody.eq(0).html('<p>Are you sure you want to delete '+vidTitle.trim()+'?</p>');
    });

    $('.slider.responsive').slick({
		  dots: true,
			prevArrow: $('.prev'),
			nextArrow: $('.next'),
		  infinite: false,
		  speed: 300,
		  slidesToShow: 2,
		  slidesToScroll: 2
		});

    $('.slide-img-wrapper').on('click', function(e){
    	var $this = $(this);
    	var images = $this.find('img');
    	var imgSelector = $(images[1]);
    	$('iframe#vid-view').attr('src', imgSelector.data('vid-url'));
    	$('h4#vid-title').text(imgSelector.attr('alt').length <= 45 ? imgSelector.attr('alt') : imgSelector.attr('alt').substr(0, 45)+'...');
    	//console.log($(images[1]).data('vid-url'));

    });

	});
	if($('#project-updates-menu').length > 0){
		$('#project-updates-menu').affix({
		offset: {
			top: $('.project-updates').offset().top - 10
		}
		});
		
	}


	$(".product-item").on("click", function(e){
		console.log("Working");
		var $this = $(this);
		if($this.hasClass("active")) return false;
		var description = $($this.next("div"));
		var globalDesc = $(".product-description-global");
		var activeProductItem = $(".product-item.active");
		var activeProductDecs = $(".product-item-description.active");
		activeProductItem.removeClass("active");
		activeProductDecs.removeClass("active");
		$this.addClass("active");
		description.addClass("active");
		globalDesc.html(description.html());
		// console.log()
	})

	$(".gifting-info .close-btn").on("click", function(e){
		e.preventDefault();
		$(".navbar-nav .closestarted").addClass('getstarted').removeClass('closestarted');
	
		$('#mainNav').removeClass('hasLanding');
		$('#landingPage').slideUp();
	})
